import { z } from 'zod';

export const companySchema = z.object({
  name: z.string(),
  code: z.string(),

  /**
   * Custom terms and conditions the guest must accept before registering on the
   * PWA. `null` (the default) means no terms are configured and registration is
   * not gated. Stored as plain text — newlines are preserved when rendered.
   */
  termsAndConditions: z.string().nullable().optional().default(null),

  _creationTime: z.number().optional(),
  _id: z.string().optional(),
  updatedAt: z.number().optional(),
});
export type CompanySchema = z.output<typeof companySchema>;

export const companyStrictSchema = companySchema.safeExtend({
  code: z.string().trim().length(3),
  // Trimmed so whitespace-only text does not gate registration behind blank terms.
  termsAndConditions: z.string().trim().nullable().optional().default(null),
});

export const companyCvxSchema = companySchema.safeExtend({
  _creationTime: z.number(),
  _id: z.string(),
  updatedAt: z.number(),
});
export type CompanyCvx = z.output<typeof companyCvxSchema>;
